var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logos" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", {
          staticStyle: { width: "20px", height: "24px" },
          attrs: { src: require("../../assets/apply/lock.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "by" }, [_vm._v("Powered by")]),
        _vm._v(" "),
        _c("img", {
          staticStyle: { height: "16px" },
          attrs: {
            src:
              "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png",
            alt: ""
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e93fc07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e93fc07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/payment-footer.vue
// module id = null
// module chunks = 